let Alert = {
    init: () => {
        if ($('.system-alert').length) Alert.initSystemAlerts();
    },

    initSystemAlerts: () => {
        $('.system-alert').each(function () {
            let $this = $(this);
            if ($this.data('sticky')) {
                return;
            }
            let $removeAlert = $('<i class="icon-close-small position-absolute remove-alert" style="right:24px"></i>'),
                $iconsWrapper = $this.find('.d-flex');

            $removeAlert.on('click', () => {
                $this.fadeOut('normal', () => $this.remove());
            });

            $iconsWrapper.append($removeAlert);

            if ($this.hasClass('system-alert-success')) {
                fadeOutAfterCreation($this);
            }
        });

        function fadeOutAfterCreation(obj) {
            setTimeout(() => {
                obj.fadeOut('slow', function () {
                    obj.remove();
                });
            }, 5000);
        }
    }
};

export default Alert;


